import {
	checkReducedGroupPermissions,
	isLesserGroupType
} from '../admin/principals/groups/admin-groups'

import Backbone from 'backbone'
import $ from 'jquery'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import formHelper from 'scoreboard/components/form-helper'
import DatasetsFilterBadges from 'scoreboard/datasets/filters/datasets-filter-badges'
import editTemplateFormDatasetInputsTemplate from './edit-template-form-dataset-inputs.hbs'
import editTemplateFormSyncOptionsTemplate from './edit-template-form-sync-options.hbs'
import Dataset from 'scoreboard/datasets/model/dataset'
import TemplateNamingForm from 'scoreboard/templates/template-naming-form'
import * as allowRecordlessCopies from './allow-recordless-copies'
const showAllowRecordlessCopiesOption = allowRecordlessCopies.showAllowRecordlessCopiesOption
const allowRecordlessCopiesLabel = allowRecordlessCopies.allowRecordlessCopiesLabel
import OrganizationTemplatePermissionsPanel from './organization-template-permissions-panel'
import OrganizationTemplatePermissions from './organization-template-permissions'
import Organization from 'scoreboard/organizations/organization'
import appDisplay from 'scoreboard/components/app-display'
import metadataObjects from '../components/metadata-objects'

var EditTemplateForm = TemplateNamingForm.extend({
	events: _.extend({
		'click .add': 'addFilter'
	}, TemplateNamingForm.prototype.events),

	initialize() {
		TemplateNamingForm.prototype.initialize.apply(this, arguments)

		if (_.isNil(this.options.copyType)) {
			if (this.options.datasetCopy || this.options.datasetTemplate) {
				this.options.copyType = 'dataset'
			} else {
				this.options.copyType = this.options.entireTreeCopy ? 'tree' : 'single'
			}
		}
	},

	render() {
		TemplateNamingForm.prototype.render.apply(this, arguments)

		this.$('.template-naming-panel.organizations').after(editTemplateFormSyncOptionsTemplate())
		formHelper.writeToDom(this.options, this.$('.sync-options'))

		if (this.options.copyType === 'dataset') {
			this.$('.dialog-body-content').append(editTemplateFormDatasetInputsTemplate())

			let treeItemsById = _.keyBy(this.options.treeItems, 'id')
			let dataset = this.options.dataset
			let field = dataset.getUnderlyingField(this.model.get('datasetFieldId'))

			this.filterBadges = new DatasetsFilterBadges({
				model: dataset,
				filters: this.options.datasetFilters,
				noneMessage: i18n.get('common.thereAreNo', 'datasets.records.activeFilters'),
				showPermissionFilters: false,
				allowAppCalendar: false,
				treeItemsById
			}).render()

			this.$('.panel-content.active-filters').append(this.filterBadges.el)

			this.filterBadges.render()

			let showRecordlessOption = showAllowRecordlessCopiesOption(field, this.options.useDatasetRanges)

			this.$('.allow-recordless-copies-section').toggleClass('is-not-displayed', !showRecordlessOption)
			if (showRecordlessOption) {
				this.$('.allow-recordless-copies-section .label-text')
					.text(allowRecordlessCopiesLabel(field))

				this.$('[name=allowRecordlessCopies]').prop('checked', !!this.options.allowRecordlessCopies)
			}

			this.permissionsPanel = new OrganizationTemplatePermissionsPanel({
				collection: new OrganizationTemplatePermissions(
					this.options.organizationTemplatePermissions),
				// #56262 use the templateId if it exists; if not, then we're
				// actually working with the template itself, so use its ID
				organizationTemplateId: this.model.get('templateId') ?? this.model.id,
				initial: {
					dataset,
					field,
					rollupTreeGroups: this.options.rollupTreeGroups
				}
			})
			this.listenTo(this.permissionsPanel, 'change', () => {
				this.formView.change()
			})
			this.$('.panel.filters').before(this.permissionsPanel.el)
			this.permissionsPanel.render()

				// Issue #56236 - fix scoll position for Firefox & Safari
				// Introduce a slight delay to ensure any asynchronous updates 
				// or layout calculations are complete.
				setTimeout(() => {
					if (this.options.scrollToPermissions) {
						this.$('.dialog-body').scrollTop(
							this.permissionsPanel.el.offsetTop)
					}
				}, 50) 

		}

		return this
	},

	submit: function () {
		var options = {
			label: _.find(this.panels, panel => panel.options.section === 'organizations').info().label
		}

		_.each(this.panels, function(panel) {
			options[panel.options.section] = panel.info()
		})

		if (this.options.copyType === 'dataset') {
			options.datasetFilters = this.filterBadges.filters
			options.organizationTemplatePermissions =
				this.permissionsPanel?.gatherData()?.organizationTemplatePermissions
		}

		let syncOptions = _.pick(formHelper.readFromDom(this.el),
			'useTemplateOwners', 'useTemplateUpdaters',
			'useTemplatePermissions', 'useTemplateRelatedItems',
			'allowRecordlessCopies')

		_.extend(options, syncOptions)

		// #55867
		// Track if we need to call doSubmit() after checking each group type
		// for the need to populate a reduced permission warning
		let permissionReduction = false

		// #56261
		// Permissions reductions only apply to dataset templates
		if (this.options?.datasetTemplate) {
			const newPermissions = options?.organizationTemplatePermissions?.models

			for (let index = 0; index < newPermissions?.length; index++) {
				const oldType = this.options?.organizationTemplatePermissions
					?.[index]?.groupType
				const newType = newPermissions?.[index]?.attributes?.groupType

				// If permissions are reduced, then we are ready to submit with
				// a warning prompt
				if (isLesserGroupType(oldType, newType)) {
					checkReducedGroupPermissions(this, oldType, newType, options)
					permissionReduction = true
					// Exit the loop, so we don't execute multiple submissions
					// in the case of multiple permission reductions
					break
				}
			}
		}

		// If we never detected a permissions reduction, submit as normal
		if (!permissionReduction) {
			this.doSubmit(options)
		}
	},

	doSubmit: function(options) {
		let templateSavePromise = $.ajax({
			type: 'POST',
			url: 'api/organizations/' + this.model.id,
			data: JSON.stringify(options),
			dataType: 'json',
			success: result => {
				_.forEach(['organizations', 'scorecards', 'reports', 'charts', 'dashboards', 'strategyMaps'], function (section) {
					let models = _.map(result[section], renamed => {
						let ModelClass = metadataObjects[section].model
						return new ModelClass(renamed)
					})

					// #55972 to help with performance, indicate that each edit
					// event is part of a batch (allowing some listeners to ignore
					// it), then raise a batch event at the end. This is similar
					// to Backbone.Collection and change/update events
					models.forEach(renamed => {
						Backbone.trigger('edit:domain-object', renamed, { batch: true })
					})

					Backbone.trigger('edit:domain-objects', models)
				})

				this.trigger('done')
			},
			error: xhr => {
				this.formView.error(xhr)
			}
		})

		return templateSavePromise
	},

	addFilter: function () {
		this.filterBadges.addFilter()
	},

	remove() {
		TemplateNamingForm.prototype.remove.apply(this, arguments)
		_.invokeMap([this.filterBadges, this.permissionsPanel],
			'remove')
	}
})

export function dialog (orgId, opt = {}) {
	let dialogFn = opt.dialogFn ?? appDisplay.dialog.bind(appDisplay)

	dialogFn($.get('api/organizations/' + orgId + '/rename-info'), info => {
		let model = new Organization(_.extend(
			{ id: orgId },
			_.pick(info, 'label', 'templateId', 'datasetFieldId', 'templateRootId')))
		let options = _.extend({
			section: 'organizations',
			model,
			scrollToPermissions: opt.scrollToPermissions
		}, info)

		if (options.dataset) {
			options.dataset = new Dataset(options.dataset)
		}

		return new EditTemplateForm(options)
	})
}

export default EditTemplateForm

EditTemplateForm.__filename__ = 'organizations/edit-template-form.js'
